import React, {ReactElement} from 'react';
import {DeviceType} from '../../../../../incase-domain/common/DeviceType.enum';
import {IQuestionReportElement} from '../../../../../incase-domain/elements/question/questionReportElement';
import RenderQuestionReport from './RenderQuestionReport';
import {IQuestionElements} from '../../../../../incase-domain/elements/question';
import {useQuestionReportData} from '../../../../../hooks/useQuestionReportData';
import ElementLoadingSkeleton from '../../../../../incase-domain/components/loadingSkeleton/ElementLoadingSkeleton';
import {useLinkedQuestionElement} from './useLinkedQuestionElement';

interface QuestionReportLiveProps {
    element: IQuestionReportElement;
    device: DeviceType;
}

// TODO: Question can be on slide that is hidden by rules. So we need to fix that (get state before applying rules)
function QuestionReportLive({element, device}: QuestionReportLiveProps): ReactElement | null {
    const questionReport = useQuestionReportData(element.questionElementId);
    const {actualQuestionElement} = useLinkedQuestionElement(element.questionElementId);

    if (!questionReport) {
        return <ElementLoadingSkeleton />;
    }

    return (
        <RenderQuestionReport
            questionReport={questionReport}
            question={actualQuestionElement as IQuestionElements}
            device={device}
            fontFamily={element.fontFamily}
        />
    );
}

export default QuestionReportLive;
